import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { basePath } from 'library/Routes';
import Backend from 'i18next-http-backend';
import { getNoCache } from 'utils/NoCacheUtils';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    lng: 'pt',
    backend: {
      loadPath: `${basePath}locales/{{lng}}/{{ns}}.json?nocache=` + getNoCache(),
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    }
  });


export default i18n;
